"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _lodash = _interopRequireDefault(require("lodash"));

var _axios = _interopRequireDefault(require("axios"));

var _basic_provider = _interopRequireDefault(require("./_basic_provider"));

var _bluebird = _interopRequireDefault(require("bluebird"));

var _browserOrNode = require("browser-or-node");

var _uuid = _interopRequireDefault(require("uuid"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FilesApi =
/*#__PURE__*/
function (_BasicProviderApi) {
  (0, _inherits2.default)(FilesApi, _BasicProviderApi);

  /**
   * @constructor
   */
  function FilesApi(_ref) {
    var _this;

    var userTokenFactory = _ref.userTokenFactory,
        fingerPrintTokenFactory = _ref.fingerPrintTokenFactory,
        filesApiUrl = _ref.filesApiUrl,
        accountId = _ref.accountId,
        sdkApiUrl = _ref.sdkApiUrl,
        providersAccountId = _ref.providersAccountId;
    (0, _classCallCheck2.default)(this, FilesApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FilesApi).call(this, {
      userTokenFactory: userTokenFactory,
      fingerPrintTokenFactory: fingerPrintTokenFactory,
      sdkApiUrl: sdkApiUrl,
      providersAccountId: providersAccountId
    }));
    _this.filesApiUrl = filesApiUrl;
    _this.accountId = accountId;
    return _this;
  }

  (0, _createClass2.default)(FilesApi, [{
    key: "serviceMetadata",
    value: function () {
      var _serviceMetadata = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee() {
        var _this2 = this;

        var headers;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context.sent;
                return _context.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this2.filesApiUrl, "/api/meta"), headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function serviceMetadata() {
        return _serviceMetadata.apply(this, arguments);
      }

      return serviceMetadata;
    }()
  }, {
    key: "headObject",
    value: function () {
      var _headObject = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(key, isPublic) {
        var _this3 = this;

        var headers;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context2.sent;
                return _context2.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this3.filesApiUrl, "/api/file?").concat(FilesApi._buildQueryParams(_objectSpread({
                    key: key,
                    isPublic: isPublic
                  }, _this3.accountId ? {
                    accountId: _this3.accountId
                  } : {}))), headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function headObject(_x, _x2) {
        return _headObject.apply(this, arguments);
      }

      return headObject;
    }()
  }, {
    key: "headFolder",
    value: function () {
      var _headFolder = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(key) {
        var _this4 = this;

        var headers;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context3.sent;
                return _context3.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this4.filesApiUrl, "/api/folder?").concat(FilesApi._buildQueryParams(_objectSpread({
                    key: key
                  }, _this4.accountId ? {
                    accountId: _this4.accountId
                  } : {}))), headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function headFolder(_x3) {
        return _headFolder.apply(this, arguments);
      }

      return headFolder;
    }()
  }, {
    key: "getDownloadUrl",
    value: function () {
      var _getDownloadUrl = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(key, isPublic, expires) {
        var _this5 = this;

        var invalidateCache,
            headers,
            url,
            _args4 = arguments;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                invalidateCache = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : false;
                _context4.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context4.sent;
                _context4.next = 6;
                return _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this5.filesApiUrl, "/api/url?").concat(FilesApi._buildQueryParams(_objectSpread({
                    key: key,
                    isPublic: isPublic,
                    expires: expires
                  }, _this5.accountId ? {
                    accountId: _this5.accountId
                  } : {}))), headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                });

              case 6:
                url = _context4.sent;

                if (!(isPublic && invalidateCache)) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt("return", "".concat(url, "?invalidateCache=").concat(_uuid.default.v4()));

              case 9:
                return _context4.abrupt("return", url);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getDownloadUrl(_x4, _x5, _x6) {
        return _getDownloadUrl.apply(this, arguments);
      }

      return getDownloadUrl;
    }()
  }, {
    key: "getSystemDownloadUrl",
    value: function () {
      var _getSystemDownloadUrl = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(postfix, name, options) {
        var _this6 = this;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", _bluebird.default.try(function () {
                  return _this6._callApi({
                    method: 'POST',
                    path: 'downloadurl',
                    payload: _objectSpread({
                      postfix: postfix,
                      name: name
                    }, !_lodash.default.isEmpty(options) && options)
                  });
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function getSystemDownloadUrl(_x7, _x8, _x9) {
        return _getSystemDownloadUrl.apply(this, arguments);
      }

      return getSystemDownloadUrl;
    }()
  }, {
    key: "getUploadUrl",
    value: function () {
      var _getUploadUrl = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(_ref2, isPublic, expires) {
        var _this7 = this;

        var key, contentType, maxFileSize, cacheControl, headers;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                key = _ref2.key, contentType = _ref2.contentType, maxFileSize = _ref2.maxFileSize, cacheControl = _ref2.cacheControl;
                _context6.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context6.sent;
                return _context6.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.post("".concat(_this7.filesApiUrl, "/api/url?").concat(FilesApi._buildQueryParams(_objectSpread({
                    isPublic: isPublic,
                    expires: expires
                  }, _this7.accountId ? {
                    accountId: _this7.accountId
                  } : {}))), {
                    key: key,
                    contentType: contentType,
                    maxFileSize: maxFileSize,
                    cacheControl: cacheControl
                  }, headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getUploadUrl(_x10, _x11, _x12) {
        return _getUploadUrl.apply(this, arguments);
      }

      return getUploadUrl;
    }()
  }, {
    key: "getSystemUploadUrl",
    value: function () {
      var _getSystemUploadUrl = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(postfix, files, options) {
        var _this8 = this;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", _bluebird.default.try(function () {
                  return _this8._callApi({
                    method: 'POST',
                    path: 'uploadfile',
                    payload: _objectSpread({
                      postfix: postfix,
                      files: _lodash.default.map(files, function (file) {
                        return _lodash.default.omit(file, ['fileDescriptor']);
                      })
                    }, !_lodash.default.isEmpty(options) && options)
                  });
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function getSystemUploadUrl(_x13, _x14, _x15) {
        return _getSystemUploadUrl.apply(this, arguments);
      }

      return getSystemUploadUrl;
    }()
  }, {
    key: "uploadFile",
    value: function () {
      var _uploadFile = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(_ref3) {
        var fileModel, prefix, isPublic, expires, progress, maxFileSize, ttl, type, name, contentType, cacheControl, _ref4, url, fields, FormDataLib, formData;

        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                fileModel = _ref3.fileModel, prefix = _ref3.prefix, isPublic = _ref3.isPublic, expires = _ref3.expires, progress = _ref3.progress, maxFileSize = _ref3.maxFileSize, ttl = _ref3.ttl;
                type = fileModel.type, name = fileModel.name;
                contentType = type || 'binary/octet-stream';
                cacheControl = ttl ? "max-age=".concat(ttl) : 'no-cache';
                _context8.next = 6;
                return this.getUploadUrl({
                  key: prefix + name,
                  contentType: contentType,
                  maxFileSize: maxFileSize,
                  cacheControl: cacheControl
                }, isPublic, expires);

              case 6:
                _ref4 = _context8.sent;
                url = _ref4.url;
                fields = _ref4.fields;
                FormDataLib = _browserOrNode.isNode ? require('form-data') : FormData; // eslint-disable-line no-undef

                formData = new FormDataLib();

                _lodash.default.forEach(fields, function (value, key) {
                  formData.append(key, value);
                });

                formData.append('cache-control', cacheControl);
                formData.append('content-type', contentType);
                formData.append('File', fileModel.file, name);

                if (!_browserOrNode.isNode) {
                  _context8.next = 17;
                  break;
                }

                return _context8.abrupt("return", new _bluebird.default(function (resolve, reject) {
                  formData.submit(url, function (error) {
                    if (error) return reject(error);
                    resolve();
                  });
                }));

              case 17:
                return _context8.abrupt("return", _axios.default.post(url, formData, {
                  onUploadProgress: _lodash.default.isFunction(progress) ? function (event) {
                    return progress(event, name);
                  } : null
                }));

              case 18:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function uploadFile(_x16) {
        return _uploadFile.apply(this, arguments);
      }

      return uploadFile;
    }()
  }, {
    key: "uploadSystemFiles",
    value: function () {
      var _uploadSystemFiles = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(postfix, files, options) {
        var patchedFiles, uploadParams, FormDataLib, formData;
        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                // files: [{name, size, contentType, ttl, fileDescriptor}]
                patchedFiles = _lodash.default.map(files, function (file) {
                  var cacheControl = file.ttl ? "max-age=".concat(file.ttl) : 'no-cache';
                  return _objectSpread({}, file, {
                    cacheControl: cacheControl
                  });
                });
                _context10.next = 3;
                return this.getSystemUploadUrl(postfix, patchedFiles, options);

              case 3:
                uploadParams = _context10.sent;
                FormDataLib = _browserOrNode.isNode ? require('form-data') : FormData; // eslint-disable-line no-undef

                formData = new FormDataLib();
                return _context10.abrupt("return", _bluebird.default.map(uploadParams,
                /*#__PURE__*/
                function () {
                  var _ref5 = (0, _asyncToGenerator2.default)(
                  /*#__PURE__*/
                  _regenerator.default.mark(function _callee9(params, index) {
                    var url, fields, file;
                    return _regenerator.default.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            url = params.url, fields = params.fields;
                            file = patchedFiles[index];

                            _lodash.default.forEach(fields, function (value, key) {
                              formData.append(key, value);
                            });

                            formData.append('cache-control', file.cacheControl);
                            formData.append('content-type', file.contentType);
                            formData.append('File', file.fileDescriptor, file.name);
                            return _context9.abrupt("return", _axios.default.post(url, formData));

                          case 7:
                          case "end":
                            return _context9.stop();
                        }
                      }
                    }, _callee9);
                  }));

                  return function (_x20, _x21) {
                    return _ref5.apply(this, arguments);
                  };
                }()));

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function uploadSystemFiles(_x17, _x18, _x19) {
        return _uploadSystemFiles.apply(this, arguments);
      }

      return uploadSystemFiles;
    }()
  }, {
    key: "ls",
    value: function () {
      var _ls = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(_ref6) {
        var isPublic, prefix, headers, nextToken, totalItems, queryParams, _data, items, rest;

        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                isPublic = _ref6.isPublic, prefix = _ref6.prefix;
                _context11.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context11.sent;
                nextToken = null;
                totalItems = [];

              case 6:
                queryParams = _objectSpread({
                  isPublic: isPublic,
                  prefix: prefix
                }, this.accountId ? {
                  accountId: this.accountId
                } : {});

                if (nextToken) {
                  queryParams.nextToken = nextToken;
                }

                _context11.next = 10;
                return _axios.default.get("".concat(this.filesApiUrl, "/api/files?").concat(FilesApi._buildQueryParams(queryParams)), headers);

              case 10:
                _data = _context11.sent.data;
                items = _data.items;
                rest = (0, _objectWithoutProperties2.default)(_data, ["items"]);
                nextToken = rest.nextToken;
                totalItems = _lodash.default.chain(totalItems).concat(items).sortBy().value();

              case 15:
                if (nextToken) {
                  _context11.next = 6;
                  break;
                }

              case 16:
                return _context11.abrupt("return", totalItems);

              case 17:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function ls(_x22) {
        return _ls.apply(this, arguments);
      }

      return ls;
    }()
  }, {
    key: "listFiles",
    value: function () {
      var _listFiles = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(_ref7) {
        var isPublic, term, excludeFolderNames, headers, nextToken, items, queryParams, _data2, files, rest;

        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                isPublic = _ref7.isPublic, term = _ref7.term, excludeFolderNames = _ref7.excludeFolderNames;
                _context12.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context12.sent;
                nextToken = null;
                items = [];

              case 6:
                queryParams = _objectSpread({
                  isPublic: isPublic,
                  term: term,
                  excludeFolderNames: excludeFolderNames
                }, this.accountId ? {
                  accountId: this.accountId
                } : {});

                if (nextToken) {
                  queryParams.nextToken = nextToken;
                }

                _context12.next = 10;
                return _axios.default.get("".concat(this.filesApiUrl, "/api/files/search?").concat(FilesApi._buildQueryParams(queryParams)), headers);

              case 10:
                _data2 = _context12.sent.data;
                files = _data2.files;
                rest = (0, _objectWithoutProperties2.default)(_data2, ["files"]);
                nextToken = rest.nextToken;
                items = _lodash.default.chain(items).concat(files).sortBy().value();

              case 15:
                if (nextToken) {
                  _context12.next = 6;
                  break;
                }

              case 16:
                return _context12.abrupt("return", items);

              case 17:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function listFiles(_x23) {
        return _listFiles.apply(this, arguments);
      }

      return listFiles;
    }()
  }, {
    key: "createFolder",
    value: function () {
      var _createFolder = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13(folderPath) {
        var _this9 = this;

        var headers, queryParams;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context13.sent;
                queryParams = this.accountId ? {
                  accountId: this.accountId
                } : {};
                return _context13.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.post("".concat(_this9.filesApiUrl, "/api/files?").concat(FilesApi._buildQueryParams(queryParams)), {
                    key: folderPath
                  }, headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 5:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function createFolder(_x24) {
        return _createFolder.apply(this, arguments);
      }

      return createFolder;
    }()
  }, {
    key: "renameFile",
    value: function () {
      var _renameFile = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee14(key, newKey, isPublic) {
        var _this10 = this;

        var headers;
        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context14.sent;
                return _context14.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.put("".concat(_this10.filesApiUrl, "/api/files?").concat(FilesApi._buildQueryParams(_objectSpread({
                    key: key,
                    isPublic: isPublic
                  }, _this10.accountId ? {
                    accountId: _this10.accountId
                  } : {}))), {
                    newKey: newKey
                  }, headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function renameFile(_x25, _x26, _x27) {
        return _renameFile.apply(this, arguments);
      }

      return renameFile;
    }()
  }, {
    key: "changePrivacy",
    value: function () {
      var _changePrivacy = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee15(key, newPrivacy, isPublic) {
        var _this11 = this;

        var headers;
        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context15.sent;
                return _context15.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.patch("".concat(_this11.filesApiUrl, "/api/files?").concat(FilesApi._buildQueryParams(_objectSpread({
                    key: key,
                    isPublic: isPublic
                  }, _this11.accountId ? {
                    accountId: _this11.accountId
                  } : {}))), {
                    newPrivacy: newPrivacy
                  }, headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function changePrivacy(_x28, _x29, _x30) {
        return _changePrivacy.apply(this, arguments);
      }

      return changePrivacy;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee16(key, isPublic) {
        var _this12 = this;

        var headers;
        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context16.sent;
                return _context16.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.delete("".concat(_this12.filesApiUrl, "/api/files?").concat(FilesApi._buildQueryParams(_objectSpread({
                    key: key,
                    isPublic: isPublic
                  }, _this12.accountId ? {
                    accountId: _this12.accountId
                  } : {}))), headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function _delete(_x31, _x32) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }], [{
    key: "_buildQueryParams",
    value: function _buildQueryParams(mapping) {
      return _lodash.default.chain(mapping).map(function (value, key) {
        return "".concat(key, "=").concat(!_lodash.default.isNil(value) ? encodeURIComponent(value) : '');
      }).join('&').value();
    }
  }]);
  return FilesApi;
}(_basic_provider.default);

var _default = FilesApi;
exports.default = _default;